import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getClasses } from "../ApiService/ApiService";

export const fetchClassesAsync = createAsyncThunk(
  "classes/fetchClasses",
  async () => {
    const response = await getClasses();
    return response.data;
  }
);

const initialState = {
  classes: [],
  loading: false,
  error: null,
};

export const classesSlice = createSlice({
  name: "classes",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchClassesAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClassesAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.classes = action.payload;
      })
      .addCase(fetchClassesAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const selectAllClasses = (state) => state.classes.classes;
export const selectClassesLoading = (state) => state.classes.loading;
export const selectClassesError = (state) => state.classes.error;

export default classesSlice.reducer;
